<template>
    <Sheet v-loading="loading.actions['booking']">
        <div style="margin-bottom: 10px;">
            <el-divider >
            <span style="font-size:1.1rem;padding-right: 10px;">
                一般場地借用(採登記送審制，含籃球、排球白天借用)
            </span>
            </el-divider>
            <span style="padding-right: 5px;">選擇場地</span>
            <el-select
                    placeholder="請選擇場地"
                    v-model="selectedRoomId"
            >
                <el-option
                        v-for="room in rooms"
                        :key="room.id"
                        :value="room.id"
                        :label="room.name"
                >
                </el-option>
            </el-select>
        </div>
        <div style="display: flex; flex-direction: column; flex-grow: 1;height: 620px;" id="normalBooking">
            <calendar-view
                    locale="zh-Tw"
                    :disablePast="true"
                    :show-date="showDate"
                    class="theme-default"
                    @click-date="selectDate"
                    @click-event="selectEvent"
                    :events="events"
                    :startingDayOfWeek="1"
                    eventContentHeight="1.5em"
            >
                <template #header="{headerProps}">
                    <calendar-view-header :header-props="headerProps" @input="changeMonth"/>
                </template>

            </calendar-view>
        </div>
        <el-dialog
                :visible.sync="showForm"
                @opened="onOpened"
                @closed="onClosed"
                top="5vh"
                width="960px"
        >
            <template #title>
                {{(selectedRoom || {name:''}).name}}
                (※多天期借用，以同時段為限)
            </template>
            <el-form
                    ref="form"
                    :rules="rules"
                    :model="applyForm"
                    label-width="280px"

            >
                <el-form-item label="活動日期 " prop="range">
                   <template #label>
                     <span>活動日期</span>
                     <small>Event date</small>
                   </template>
                    <el-date-picker
                            type="daterange"
                            v-model="applyForm.range"
                            :picker-options="pickerOptions"
                            start-placeholder="請選擇開始日期 Please select start date"
                            end-placeholder="請選擇結束日期 Please select end date"
                            @change="onRangeChange"
                            :clearable="false"
                    ></el-date-picker>
                </el-form-item>
                <el-form-item label="時段 Time period" prop="periodIds">
                  <template #label>
                    <span>時段</span>
                    <small>Time period</small>
                  </template>
                    <el-select
                            v-model="applyForm.periodIds"
                            prop="periodIds"
                            multiple
                            :editable="false"
                            no-data-text="該期間查無可借用的時段"
                            :placeholder="availablePeriodsInRange.length > 0 ? '請選擇時段' : '無可用時段'"
                    >
                        <el-option
                                v-for="period in availablePeriodsInRange"
                                :key="period.id"
                                :value="period.id"
                                :label="`${period.tag}(${period.timeBegin}~${period.timeEnd})`"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="活動名稱摘要 Summary of Activity Name" prop="activity">
                  <template #label>
                    <span>活動名稱摘要</span>
                    <small>Summary of Activity Name</small>
                  </template>
                    <el-input
                            type="textarea"
                            v-model="applyForm.activity"
                            placeholder="請輸入活動名稱摘要(ex:休管系男排或女排(籃)練習...) Please enter a summary of the activity name"
                    ></el-input>
                </el-form-item>
                <el-form-item label="參加人數 Number of participants" prop="numberOfParticipants">
                  <template #label>
                    <span>參加人數</span>
                    <small>Number of participants</small>
                  </template>
                    <el-input-number
                            :min="1"
                            :max="10000"
                            v-model="applyForm.numberOfParticipants"
                            placeholder="請輸入參加人數"
                    ></el-input-number>
                </el-form-item>
                <el-form-item label="參加對象 Participants" prop="participants">
                  <template #label>
                    <span>參加對象</span>
                    <small>Participants</small>
                  </template>
                    <el-input
                            v-model="applyForm.participants"
                            type="textarea"
                            placeholder="請輸入參加對象 Please enter the participants"
                    ></el-input>
                </el-form-item>
                <el-form-item label="手機號碼 Cell Phone Number" prop="contact">
                  <template #label>
                    <span>手機號碼</span>
                    <small>Cell Phone Number</small>
                  </template>
                    <el-input
                            v-model="applyForm.contact"
                            placeholder="請輸入手機號碼(格式:09xx-xxxxxx) Please enter the cell phone number"
                    ></el-input>
                </el-form-item>
                <el-form-item label="郵件信箱 E-Mail" prop="email">
                  <template #label>
                    <span>郵件信箱</span>
                    <small>E-Mail</small>
                  </template>
                    <el-input
                            v-model="applyForm.email"
                            placeholder="請輸入郵件信箱 Please enter the email"
                    ></el-input>
                </el-form-item>
                <el-form-item label="單位主管或指導老師" prop="advisor">
                    <template #label>
                      <span>單位主管或指導老師</span>
                      <small>Supervisor or Instructor</small>
                    </template>
                    <el-input
                            v-model="applyForm.advisor"
                            placeholder="請輸入單位主管或系主任、指導老師 Please enter the unit supervisor or department head, instructor"
                    ></el-input>
                </el-form-item>
                <el-form-item label="器材數量 Quantity of Equipment">
                  <template #label>
                    <span>器材數量</span>
                    <small>Quantity of Equipment</small>
                  </template>
                    <el-input
                            v-model="applyForm.equipments"
                            type="textarea"
                            placeholder="請輸入器材數量(ex:桌子X2、椅子X4) Please enter the quantity of equipment"
                    ></el-input>
                </el-form-item>
                <el-form-item label="檢附文件 Attached Documents">
                  <template #label>
                    <span>檢附文件</span>
                    <small>Attached Documents</small>
                  </template>
                    <small>※活動企劃書(練習及社團時間免附計畫書)或簽核文件</small>
                    <el-upload
                            ref="upload"
                            :before-upload="beforeUpload"
                            :before-remove="handleBeforeRemove"
                            :on-error="onUploadError"
                            :on-exceed="onExceedLimit"
                            :limit="fileLimit"
                            :headers="uploadHeaders"
                            :action="action"
                            :data="dataOptions"
                            :on-success="onUploadSuccess"
                    >
                        <el-button>選擇檔案</el-button>
                        <template #tip>
                            <div class="el-upload__tip">
                                檔案不超過5MB
                            </div>
                        </template>
                    </el-upload>
                </el-form-item>
            </el-form>
            <el-alert
                    :closable="false"
                    type="warning"
            >
                <small>
                    <div v-html="(viewContent ||{}).bookingWarning"></div>
                </small>
            </el-alert>
            <template #footer>
                <el-button @click="submit" :loading="loading.actions['booking']" type="primary">送出申請 <span>Apply</span></el-button>
                <el-button @click="showForm=false">取消 <span>Cancel</span></el-button>
            </template>
        </el-dialog>
    </Sheet>
</template>

<script>
    import {CalendarView, CalendarViewHeader, CalendarMathMixin} from 'vue-simple-calendar';

    require('vue-simple-calendar/static/css/default.css');
    import {mapState, mapActions, mapGetters} from 'vuex';
    import UploadMixin from '../../uploadMixin';
    import moment from 'moment';

    const defaultForm = {
        activity: '',
        numberOfParticipants: 1,
        participants: '',
        equipments: '',
        advisor: '',
        certificate: undefined,
        range: [],
        periodIds: [],
        contact: '',
        email: ''
    };

    export default {
        name: 'NormalBooking',
        components: {
            CalendarView,
            CalendarViewHeader,
        },
        mixins: [CalendarMathMixin, UploadMixin],
        data: () => ({
            selectedDate: undefined,
            showForm: false,
            showDate: new Date(),
            selectedRoomId: undefined,
            applyForm: {...defaultForm},
            rules: {
                activity: [
                    {required: true, message: '請輸入活動名稱摘要', trigger: 'blur'}
                ],
                numberOfParticipants: [
                    {required: true, message: '請輸入參加人數!', trigger: 'blur'},
                    {
                        range: {min: 1, max: 10000},
                        message: '請輸入大於0的數字!',
                        trigger: 'blur',
                        transform(value) {
                            return value.toString();
                        }
                    },
                ],
                participants: [
                    {required: true, message: '請輸入參加對象', trigger: 'blur'}
                ],
                contact: [
                    {required: true, message: '請輸入手機號碼', trigger: 'blur'},
                    {pattern: /^09\d{2}-\d{6}$/, message: '手機號碼格式請使用09xx-xxxxxx', trigger: 'blur'},
                ],
                advisor: [
                    {required: true, message: '請輸入單位主管或系主任、指導老師', trigger: 'blur'}
                ],
                range: [
                    {required: true, message: '請選擇預約日期起訖'}
                ],
                periodIds: [
                    {required: true, message: '請選擇時段'}
                ],
                email: [
                    {required: true, message: '請輸入電子郵件信箱', trigger: 'blur'},
                    {pattern: /^\w+((-\w+)|(\.\w+))*\@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z]+$/
                        , message: '郵件格式錯誤', trigger: 'blur'},
                ]
            }
        }),

        computed: {
            ...mapState('setting', {
                rooms: state => state.rooms,
                sys: state => state.sys,
                months: state => state.months
            }),
            ...mapState(['loading']),
            ...mapState('booking', ['periods', 'booked', 'availablePeriodsInRange']),
            ...mapState('setting', ['viewContent']),
            ...mapGetters('booking', {
                usedTimes: 'usedTimes'
            }),
            ...mapGetters('auth', ['token', 'isBookable']),
            selectedRoom() {
                return this.rooms.find(r => r.id === this.selectedRoomId) || {};
            },

            events() {
                const {ncutRoomId} = (this.selectedRoom || {});
                const grpByWeekDay = this.usedTimes
                    .filter(u => u.roomId === ncutRoomId)
                    .reduce((lst, ut) => lst.concat(ut.periods.map(p => ({...p, weekday: ut.weekday}))), [])
                    .reduce((grp, p) => {
                        (grp[p.weekday] = (grp[p.weekday] || [])).push(p);
                        return grp;
                    }, {});

                const coursedUsed = Object.keys(grpByWeekDay)
                    .reduce((events, key) => {
                      return events
                          .concat(
                              this.getDisplayDates[key]
                                  .filter(d => d.isValid)
                                  .map(d => d.date)
                                  .reduce((periods, date) => {
                                    return periods.concat(grpByWeekDay[key]
                                        .map(g => (
                                            {
                                              startDate: `${date} ${g.timeBegin}`,
                                              title: `${g.tag}(${g.timeBegin}~${g.timeEnd})-已排體育課`,
                                              id: `${moment(date).format('YYYY-MM-DD')}(${g.id})`,
                                              periodId: g.id,
                                              type: 'course'
                                            })))
                                  }, [])
                          );
                    }, []);

                // book prior to course schedule will cause the course schedule disappear in calendar,
                // but it is acceptable since the booked event will cover the course schedule in calendar and show as booked,
                // which is more intuitive for users
                const rst = [...coursedUsed, ...this.booked].reduce((unique, o) => {
                    if (!unique.some(u => u.id === o.id)) {
                        unique.push(o);
                    }
                    return unique;
                }, []);

                return rst;
            },

            getDisplayDates() {
                const {dateBegin, dateEnd} = this.sys;
                const periodStart = this.beginningOfPeriod(this.showDate, 'month', 0);


                const displayFirstDate = this.beginningOfWeek(periodStart, 0);
                return [...new Array(35).keys()]
                    .map(d => this.addDays(displayFirstDate, d))
                    .reduce((grp, p) => {
                        const key = p.getDay();
                        const isValid = this.isValidDate(p);
                        (grp[key] = (grp[key] = grp[key] || [])).push({
                            date : moment(p).format('YYYY-MM-DD'),
                            isValid
                        });
                        return grp;
                    }, {});
            },

            pickerOptions() {
                const self = this;
                return ({
                    disabledDate(date) {
                        return date < self.selectedDate && !self.isSameDate(date, self.selectedDate);
                    }
                });
            },
        },
        watch: {
            rooms(rooms) {
                if (rooms) {
                    this.selectedRoomId = rooms[1].id;
                }
            },
            async selectedRoomId(roomId){
                await this.getEventsOf(roomId);
            }
        },
        methods: {
            changeMonth(d){
                this.showDate = d;
            },

            async selectDate(d) {
                if(!this.isBookable){
                  this.$message.warning('只限學生借用!!')
                  return;
                }
                if(!this.isInPast(d)){
                    if(this.isValidDate(d) && this.isValidWeekday(d)){
                        this.selectedDate = d;
                        await this.show(d);
                    } else{
                        this.$message.warning('不在可借用時間內，請重新選擇!!')
                    }

                }
            },

            async selectEvent({startDate, originalEvent: {type}}) {
              if(!this.isBookable){
                this.$message.warning('只限學生借用!!')
                return;
              }
                if(!this.isInPast(startDate)){
                    if(this.isValidDate(startDate) && this.isValidWeekday(startDate)){
                        this.selectedDate = startDate;
                        await this.show(startDate);
                    }else{
                        this.$message.warning('不在可借用時間內，請重新選擇!!')
                    }
                }
            },

            isValidDate(d){
                const {dateBegin, dateEnd} = this.sys;
                return moment(d).isBetween(dateBegin, dateEnd, null, '[]') ;
            },
            isValidWeekday(d){
                const currentMonth = this.months.find(m => m.month === d.getMonth() + 1);
                return currentMonth && currentMonth.openWeekday[d.getDay()];
            },

            async show(d) {
                await this.getAvailablePeriodsInRange({
                    range: Array(2).fill(moment(d).format('YYYY-MM-DD')),
                    roomId: this.selectedRoomId
                });

                if (this.availablePeriodsInRange.length <= 0) {
                    this.$message({
                        type: 'warning',
                        message: '此日無可借用時段!',
                        duration: 1000
                    })
                } else {
                    this.showForm = true;
                    this.applyForm = {
                        ...defaultForm,
                        range: Array(2).fill(this.selectedDate)
                    }
                }
            },

            ...mapActions('booking', {
                getCourseTimes: 'getCourseTimesAction',
                getPeriods: 'getPeriodsAction',
                submitNormalForm: 'submitNormalFormAction',
                checkEvents: 'checkEventsAction',
                getAvailablePeriodsInRange: 'getAvailablePeriodsInRangeAction',
                getEventsOf: 'getBookedEventsAction'

            }),
            ...mapActions('setting', {
                getViewContent: 'getViewContentAction'
            }),

            async submit() {
                const {form} = this.$refs;

                await form.validate(async (valid) => {
                    if (valid) {

                        try {
                            await this.$confirm('確定要送出嗎', {
                                type: 'warning',
                            });
                            const formData = {
                                ...this.applyForm
                                , roomId: this.selectedRoomId
                                , range: this.applyForm.range.map(d => moment(d).format('YYYY-MM-DD'))
                                , ncutRoomId: this.selectedRoom.ncutRoomId
                            };

                            const {success, messages =[], status} = await this.submitNormalForm(formData);
                            if(success){
                                this.$message.success('預約成功，請等候審查!!');
                                this.reset();
                            } else{
                                this.$message.warning(messages.join(','));
                                this.applyForm.periodIds.splice(0);
                            }
                        } catch (e) {
                            if (e !== 'cancel') {
                                this.$message({
                                    type: 'error',
                                    message: '發生錯誤，請重試一次!'
                                });
                            }
                        }
                    } else{
                        this.$message.warning({
                            type: 'warning',
                            message: '您有欄位未輸入，請再檢查一次!!'
                        })
                    }
                });
            },

            reset() {
                this.showForm = false;
                this.applyForm = {...defaultForm};
                this.$refs.upload.clearFiles();
                this.$refs.form.clearValidate();
            },

            onClosed() {
                this.reset();
            },

            onOpened() {
                this.$refs.form.clearValidate();
            },

            onUploadSuccess(res) {
                this.applyForm.certificate = res;
            },

            async handleBeforeRemove(file) {
                await this.beforeRemove(file);
                this.applyForm.certificate = undefined
            },

            async onRangeChange(range){
                this.applyForm.periodIds.splice(0);
                await this.getAvailablePeriodsInRange({
                    range: range.map(d => moment(d).format('YYYY-MM-DD')),
                    roomId: this.selectedRoomId
                });
            }

        },
        async created() {
            if (this.rooms.length > 0) {
                this.selectedRoomId = this.rooms[1].id;
            }
            await this.getCourseTimes();
            await this.getPeriods();
            await this.getViewContent();
        }
    }
</script>

<style>
    #normalBooking .past {
        cursor: not-allowed;
    }

    #normalBooking .today, #normalBooking .future, #normalBooking .cv-event:not(.past) {
        cursor: pointer;
    }
    #normalBooking .cv-event[title$='已被預約']{
        background-color: #003366;
        color: #ffffff;
    }

    #normalBooking .cv-event.past,  #normalBooking .cv-event[title$='已排體育課'] {
        background-color: #f9fcff;
        color: #646464;
    }
</style>
